import { Link } from "react-router-dom";
import { Server, Inbox, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

export function MigaduNotice() {
  return (
    <div className="glass mt-10 flex flex-col items-center gap-4 rounded-3xl p-12 text-center" data-testid="migadu-notice">
      <div className="glass flex h-16 w-16 items-center justify-center rounded-2xl text-sky-600">
        <Mail className="h-8 w-8" />
      </div>
      <h3 className="font-heading text-xl font-semibold text-slate-800">Email-only domain</h3>
      <p className="max-w-sm text-sm text-slate-500">
        This is a Migadu email domain. Workspace features like users, groups and sharing don't apply here — manage its mailboxes instead.
      </p>
      <Link to="/mailboxes">
        <Button className="glossy-emerald relative rounded-xl" data-testid="goto-mailboxes">
          <span className="spec-shine" />Go to Mailboxes
        </Button>
      </Link>
    </div>
  );
}

export function PageHeader({ title, subtitle, icon: Icon, actions }) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="glass flex h-12 w-12 items-center justify-center rounded-2xl text-emerald-600">
            <Icon className="h-6 w-6" />
          </div>
        )}
        <div>
          <h1 className="font-heading text-2xl font-bold text-slate-900 sm:text-3xl">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
        </div>
      </div>
      {actions}
    </div>
  );
}

export function NoDomain() {
  return (
    <div className="glass mt-10 flex flex-col items-center gap-4 rounded-3xl p-12 text-center">
      <div className="glass flex h-16 w-16 items-center justify-center rounded-2xl text-emerald-600">
        <Server className="h-8 w-8" />
      </div>
      <h3 className="font-heading text-xl font-semibold text-slate-800">No workspace selected</h3>
      <p className="max-w-sm text-sm text-slate-500">
        Connect a Google Workspace domain and select it from the top bar to manage it here.
      </p>
      <Link to="/accounts">
        <Button className="glossy-emerald relative rounded-xl" data-testid="goto-accounts">
          <span className="spec-shine" />Connect a workspace
        </Button>
      </Link>
    </div>
  );
}

export function EmptyState({ label = "Nothing here yet", hint }) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-2xl bg-white/50 p-10 text-center text-slate-500">
      <Inbox className="h-8 w-8 text-slate-400" />
      <p className="font-medium">{label}</p>
      {hint && <p className="text-xs">{hint}</p>}
    </div>
  );
}

export function timeAgo(iso) {
  if (!iso) return "Never";
  const then = new Date(iso).getTime();
  if (isNaN(then) || then <= 0 || new Date(iso).getFullYear() < 1971) return "Never";
  const s = Math.floor((Date.now() - then) / 1000);
  if (s < 60) return "just now";
  const units = [
    ["year", 31536000], ["month", 2592000], ["week", 604800],
    ["day", 86400], ["hour", 3600], ["minute", 60],
  ];
  for (const [name, secs] of units) {
    const v = Math.floor(s / secs);
    if (v >= 1) return `${v} ${name}${v > 1 ? "s" : ""} ago`;
  }
  return "just now";
}
